/* eslint-disable react/jsx-props-no-spreading */
import { FC, useEffect } from 'react'
import ReactGA from 'react-ga4'
import { useSearchParams } from 'react-router-dom'
import type { ITemplate } from '../interfaces/templates'
import Default from './Default'
import { useGetOrders, ORDERS_STATUS_PARAM } from '../hooks/orders'

/**
 * Order History screen.
 *
 * Thin by design, like every sibling here: fetch on mount, fire analytics,
 * delegate rendering to `Default`. The component tree — `OrderList`, its tab
 * row, the empty and error states — is authored in SCS config and resolves
 * through `importRoute`, so no layout belongs in this file.
 */
const OrderHistory: FC<ITemplate> = ({ ...props }) => {
  const [searchParams] = useSearchParams()
  const { fetchOrders, changeOrdersFilter } = useGetOrders()

  // Read once on mount rather than subscribing: later param changes come from
  // FILTER_ORDERS, which already re-queries. Re-reading would double-fetch.
  const initialStatus = searchParams.get(ORDERS_STATUS_PARAM) || ''

  useEffect(() => {
    // `changeOrdersFilter` seeds activeFilter and fetches page 1 in one go, so
    // a `?status=` deep link opens with that tab already selected. Without the
    // param the filter stays empty, which is the "All" tab.
    if (initialStatus) {
      changeOrdersFilter(initialStatus)
    } else {
      fetchOrders()
    }

    ReactGA.send({ hitType: 'pageview', page: `/${props.container.uid}` })
    window.fbq('track', 'PageView', { page: `/${props.container.uid}` })
  }, [])

  return <Default {...props} />
}

export default OrderHistory
